import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import MainPage from '../pages/MainPage';
import AboutUsPage from '../pages/AboutUsPage';
import ContactPage from '../pages/ContactPage';
import ErrorPage from '../pages/ErrorPage';
import routes from './routes';
import TeamPage from '../pages/TeamPage';
import WaspPPage from '../pages/WaspPPage';

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path={routes.HOME} component={AboutUsPage} />
        <Route exact path={routes.CONTACT} component={ContactPage} />
        <Route exact path={routes.QUIZ} component={MainPage} />
        <Route exact path={routes.WASP_P} component={WaspPPage} />
        <Route exact path={routes.TEAM} component={TeamPage} />
        <Route exact path={routes.ERROR} render={() => <ErrorPage errorCode={500} /> } />
        <Route render={() => <ErrorPage errorCode={404} /> } />
      </Switch>
    </BrowserRouter>
  )

};

export default AppRouter;
